import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import { Input, inputTypes } from 'components/common/FormElements/Input'
import { getOnClickAndOnKeyPressDownEvents } from 'helpers/getOnClickAndOnKeyPressDownEvents'
import { DATEPICKER_THEME_COLOR_GREEN } from 'components/QuickAppointmentPage/ThreeStepper/constants'

const ScheduleBlock = ({
  className,
  displayName,
  selected,
  isCheckout,
  handleTimeSelect,
  name,
  theme = '',
  ...props
}) =>
  <Time
    data-at-schedule-block-time
    { ...props }
    data-appointment-timeslot
    className={ className }
    selected={ selected }
    theme={ theme }>
    <TimeRadio
      { ...getOnClickAndOnKeyPressDownEvents(handleTimeSelect) }
      inputType={ inputTypes.RADIO_INPUT }
      name={ name }
      isCheckout={ isCheckout }
      value={ displayName } >
      { displayName }
      <CheckCircleIcon
        alt=""
        data-at-schedule-block-icon
        asset="check-circle"
        hidden={ !selected }
        float="right"
        margin="-2px -16px -2px 0" />
    </TimeRadio>
  </Time>

ScheduleBlock.propTypes = {
  className: PropTypes.string,
  displayName: PropTypes.string,
  handleTimeSelect: PropTypes.func,
  isCheckout: PropTypes.bool,
  name: PropTypes.string,
  selected: PropTypes.bool,
  theme: PropTypes.string
}

export default ScheduleBlock

const Time = styled.div`
  margin-bottom: 10px;
  text-align: center;
  text-transform: lowercase;
  background-color: ${Theme.colors.white};
  box-shadow: inset 0 0 0 1px ${Theme.colors.light_grey_border};
  ${props => props.selected && css`
    box-shadow: 0 1px 4px ${Theme.colors.transparent_overlay_shadow}, inset 0 0 0 2px ${Theme.colors.dark_grey};
  `}
  ${props => (props.theme === DATEPICKER_THEME_COLOR_GREEN && props.selected) && css`
    box-shadow: 0 1px 4px ${Theme.colors.transparent_overlay_shadow}, inset 0 0 0 2px ${Theme.colors.green};
  `}
`

const TimeRadio = styled(Input)`
  width: 100%;
  margin-bottom: 0;
  padding: 0;

  input:focus + div {
    ${Mixin.focusOutline()}
  }

  div {
    width: 100%;
    background: transparent;
    padding: 14px 30px 14px 30px;

    ::before,
    ::after {
      content: '';
      opacity: 0;
      border: none;
    }

    ${props => !props.isCheckout && css`
      ${Mixin.responsive('padding', '14px 30px 14px 50px', '13px 6px')}
    `}
  }
`

const CheckCircleIcon = styled(Icon)`
  background-color: ${Theme.colors.white};
`
